var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHexagon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 48,
    viewBox: "0 0 42 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 67"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.6476 0L0 11.8166V35.4497L20.6414 47.2663L41.289 35.4497V11.8166L20.6476 0ZM36.7041 32.7903L20.6476 41.9789L4.59115 32.7903V14.4759L20.6476 5.28735L36.7041 14.4759V32.7903Z",
    fill: "#0F1F3C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.4727 23.6331C11.4727 28.7009 15.5809 32.8091 20.6487 32.8091C25.7165 32.8091 29.8247 28.7009 29.8247 23.6331C29.8247 18.5652 25.7165 14.457 20.6487 14.457C15.5809 14.457 11.4727 18.5652 11.4727 23.6331ZM25.2336 23.6331C25.2336 26.1607 23.1763 28.2179 20.6487 28.2179C18.121 28.2179 16.0638 26.1607 16.0638 23.6331C16.0638 21.1054 18.121 19.0482 20.6487 19.0482C23.1763 19.0482 25.2336 21.1054 25.2336 23.6331Z",
    fill: "#0F1F3C"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagon);
export default __webpack_public_path__ + "static/media/hexagon.d3b18431c01a9c728a876a9257c21fcd.svg";
export { ForwardRef as ReactComponent };